import { UserGender } from '@/core/domain/resources/enums/UserGender.ts'
import { UserRole } from '@/core/domain/resources/enums/UserRole.ts'
import { EntityValidator } from '@/core/infrastructure/utils/EntityValidator.ts'
import { type UserInputEntity, UserInputSchema } from '@/core/infrastructure/schemas/users/core/UserInputSchema.ts'

/**
 * Implémentation du type UserInputEntity
 */
export class UserInput {
  readonly identifier: string
  readonly firstname: string
  readonly lastname: string
  readonly email: string
  readonly gender: UserGender.Values
  readonly roles: UserRole.Values[]
  readonly birthdate: string | null

  constructor(user: UserInputEntity) {
    this.identifier = user.identifier
    this.firstname = user.firstname
    this.lastname = user.lastname
    this.email = user.email
    this.gender = user.gender
    this.roles = user.roles
    this.birthdate = user.birthdate ?? null
  }

  public static create(data: unknown): UserInput {
    return EntityValidator.validateAndCreate(UserInputSchema, data, UserInput, 'UserInput')
  }
}